import React, { createContext, useContext, useState } from 'react';

export const languages = {
  en: { label: 'English', flag: 'EN' },
  hi: { label: 'हिन्दी', flag: 'HI' },
  zh: { label: '中文', flag: 'ZH' },
  fr: { label: 'Français', flag: 'FR' },
  de: { label: 'Deutsch', flag: 'DE' },
  nl: { label: 'Nederlands', flag: 'NL' },
};

// Translations. Fallback to English if missing.
const dict = {
  en: {
    app_name: 'EMIWise',
    home: 'Home', calculators: 'Calculators', emi_calculator: 'EMI Calculator',
    login: 'Login', register: 'Register',
    title: 'EMI Calculator',
    subtitle: 'The Most Comprehensive EMI Calculator: Plan Prepayments, Model Moratoriums, Model Credit Days & Subvention, and Export your PDF roadmap.',
    loan_amount: 'Loan Amount', rate_of_interest: 'Rate of Interest (p.a.)', loan_tenure: 'Loan Tenure',
    yr: 'Yr', mo: 'Mo',
    monthly_emi: 'Monthly EMI', principal: 'Principal', total_interest: 'Total Interest', total_amount: 'Total amount',
    interest_type: 'Interest type', reducing_balance: 'Reducing balance', flat_rate: 'Flat rate',
    reducing_balance_desc: 'Interest is calculated on the outstanding balance every month. Standard for most banks.',
    flat_rate_desc: 'Interest is charged on the original principal for the whole tenure. Usually higher.',
    currency: 'Currency', language: 'Language',
    moratorium_enable: 'Enable moratorium period',
    moratorium_desc: 'Pause EMI payments for a set period. Interest still accrues.',
    moratorium_duration: 'Moratorium duration', months_unit: 'months',
    full_moratorium: 'Full moratorium', full_moratorium_desc: 'No payment. Interest is added to principal.',
    interest_only: 'Interest-only', interest_only_desc: 'Pay only monthly interest; principal untouched.',
    moratorium_interest_added: 'Moratorium interest added',
    you_save: 'You save',
    prepayment_title: 'Prepayment Simulator',
    prepayment_desc: 'Add lump-sum prepayments or a fixed extra amount every month, and see the interest & tenure you save.',
    extra_every_month: 'Extra amount every month',
    extra_every_month_desc: 'Paid on top of your regular EMI. Directly reduces principal.',
    none: 'None',
    lump_sum_title: 'One-time lump-sum prepayments',
    lump_sum_desc: 'Add a payment at any month during the loan.',
    add: 'Add', month: 'Month', at_month: 'at month',
    interest_saved: 'Interest saved', tenure_shortened: 'Tenure shortened', new_payoff_time: 'New payoff time',
    amortization_title: 'Amortization Schedule',
    amortization_desc: 'Month-by-month breakup',
    payoff_in: 'payoff in',
    rows: 'rows',
    phase: 'Phase', payment: 'Payment', prepay: 'Prepay', balance: 'Balance',
    moratorium: 'Moratorium', emi_phase: 'EMI',
    download_pdf: 'Download PDF',
    download_csv: 'Download CSV',
    what_is_emi_title: 'What is an EMI Calculator?',
    what_is_emi_body: 'An EMI (Equated Monthly Installment) calculator is a simple tool that helps you figure out the fixed amount you pay every month towards a home, car, personal or education loan. Move the sliders — loan amount, interest rate and tenure — and it instantly shows your monthly EMI, total interest and total amount payable.',
    feature_1_t: 'Instant Results', feature_1_d: 'See your EMI, interest and total payment update in real time as you tweak the numbers.',
    feature_2_t: 'Clear Breakup', feature_2_d: 'Visual split of principal vs interest so you know exactly where every unit goes.',
    feature_3_t: 'Budget Better', feature_3_d: 'Test different tenures to find an EMI that comfortably fits your monthly cash-flow.',
    feature_4_t: 'Save Smarter', feature_4_d: 'Compare loan offers side by side and pick the option with the lowest interest outgo.',
    formula_title: 'The EMI Formula',
    formula_note: 'where P is the principal, R is the monthly interest rate, and N is the number of monthly installments.',
    faq_title: 'Frequently Asked Questions',
    faq_desc: 'Everything you need to know about EMIs and loan planning.',
    other_calc_title: 'Other calculators',
    other_calc_desc: 'Explore more tools to plan your finances.',
    calculate: 'Calculate',
    footer_products: 'Products', footer_calculators: 'Calculators', footer_company: 'Company', footer_support: 'Support',
    footer_copyright: 'Calculators are for illustrative purposes only.',
    invest_the_difference: 'Invest the difference',
    all_products: 'All Products',
  },
  hi: {
    app_name: 'EMIWise',
    home: 'होम', calculators: 'कैलकुलेटर', emi_calculator: 'ईएमआई कैलकुलेटर',
    login: 'लॉगिन', register: 'रजिस्टर',
    title: 'ईएमआई कैलकुलेटर',
    subtitle: 'सबसे व्यापक ईएमआई कैलकुलेटर: प्री-पेमेंट की योजना बनाएँ, मोरेटोरियम मॉडल करें, मुद्रा बदलें और अपना पीडीएफ रोडमैप निर्यात करें।',
    loan_amount: 'लोन राशि', rate_of_interest: 'ब्याज दर (प्रति वर्ष)', loan_tenure: 'लोन अवधि',
    yr: 'वर्ष', mo: 'माह',
    monthly_emi: 'मासिक ईएमआई', principal: 'मूलधन', total_interest: 'कुल ब्याज', total_amount: 'कुल राशि',
    interest_type: 'ब्याज का प्रकार', reducing_balance: 'घटती शेष राशि', flat_rate: 'फ्लैट दर',
    reducing_balance_desc: 'हर महीने बकाया राशि पर ब्याज की गणना होती है। अधिकांश बैंकों में यही मानक है।',
    flat_rate_desc: 'पूरी अवधि के लिए मूल राशि पर ब्याज लिया जाता है। आमतौर पर अधिक महँगा।',
    currency: 'मुद्रा', language: 'भाषा',
    moratorium_enable: 'मोरेटोरियम अवधि सक्षम करें',
    moratorium_desc: 'तय अवधि के लिए ईएमआई रोकें। ब्याज फिर भी जुड़ता रहेगा।',
    moratorium_duration: 'मोरेटोरियम अवधि', months_unit: 'माह',
    full_moratorium: 'पूर्ण मोरेटोरियम', full_moratorium_desc: 'कोई भुगतान नहीं। ब्याज मूलधन में जुड़ जाता है।',
    interest_only: 'केवल ब्याज', interest_only_desc: 'केवल मासिक ब्याज दें; मूलधन अपरिवर्तित।',
    moratorium_interest_added: 'मोरेटोरियम ब्याज जोड़ा गया',
    you_save: 'आप बचाते हैं',
    prepayment_title: 'प्री-पेमेंट सिम्युलेटर',
    prepayment_desc: 'एकमुश्त प्री-पेमेंट या हर महीने अतिरिक्त राशि जोड़ें और देखें कि आप कितना ब्याज व अवधि बचाते हैं।',
    extra_every_month: 'हर महीने अतिरिक्त राशि',
    extra_every_month_desc: 'नियमित ईएमआई के ऊपर भुगतान। सीधे मूलधन घटाता है।',
    none: 'कोई नहीं',
    lump_sum_title: 'एकमुश्त प्री-पेमेंट',
    lump_sum_desc: 'लोन के किसी भी महीने में भुगतान जोड़ें।',
    add: 'जोड़ें', month: 'माह', at_month: 'माह में',
    interest_saved: 'ब्याज बचाया', tenure_shortened: 'अवधि घटी', new_payoff_time: 'नयी पूर्ण अवधि',
    amortization_title: 'ऋणमोक्षण अनुसूची',
    amortization_desc: 'मासिक विभाजन',
    payoff_in: 'में समाप्त',
    rows: 'पंक्तियाँ',
    phase: 'चरण', payment: 'भुगतान', prepay: 'प्री-पे', balance: 'शेष',
    moratorium: 'मोरेटोरियम', emi_phase: 'ईएमआई',
    download_pdf: 'पीडीएफ डाउनलोड करें',
    download_csv: 'CSV डाउनलोड करें',
    what_is_emi_title: 'ईएमआई कैलकुलेटर क्या है?',
    what_is_emi_body: 'ईएमआई कैलकुलेटर एक सरल टूल है जो होम, कार, व्यक्तिगत या शिक्षा लोन के लिए हर महीने देय निश्चित राशि की गणना करता है। सिर्फ स्लाइडर घुमाइए और तुरन्त मासिक ईएमआई, कुल ब्याज व देय कुल राशि देखिए।',
    feature_1_t: 'तुरन्त परिणाम', feature_1_d: 'मान बदलते ही ईएमआई, ब्याज और कुल भुगतान लाइव अपडेट होता है।',
    feature_2_t: 'स्पष्ट विभाजन', feature_2_d: 'मूलधन व ब्याज का दृश्य विभाजन ताकि हर रुपये का पता चले।',
    feature_3_t: 'बेहतर बजट', feature_3_d: 'अलग-अलग अवधियाँ आज़माकर ऐसी ईएमआई खोजें जो आपके मासिक बजट में फिट हो।',
    feature_4_t: 'समझदारी से बचत', feature_4_d: 'ऑफ़र्स की तुलना करें और सबसे कम ब्याज वाला विकल्प चुनें।',
    formula_title: 'ईएमआई का सूत्र',
    formula_note: 'जहाँ P मूलधन, R मासिक ब्याज दर और N कुल मासिक किश्तों की संख्या है।',
    faq_title: 'अक्सर पूछे जाने वाले प्रश्न',
    faq_desc: 'ईएमआई व लोन योजना के बारे में जानने योग्य सब कुछ।',
    other_calc_title: 'अन्य कैलकुलेटर',
    other_calc_desc: 'अपनी वित्तीय योजना बनाने के अन्य उपकरण।',
    calculate: 'गणना करें',
    footer_products: 'उत्पाद', footer_calculators: 'कैलकुलेटर', footer_company: 'कंपनी', footer_support: 'सहायता',
    footer_copyright: 'कैलकुलेटर केवल उदाहरण हेतु हैं।',
    invest_the_difference: 'अन्तर निवेश करें',
    all_products: 'सभी उत्पाद',
  },
  zh: {
    app_name: 'EMIWise',
    home: '首页', calculators: '计算器', emi_calculator: 'EMI 计算器',
    login: '登录', register: '注册',
    title: 'EMI 计算器',
    subtitle: '最全面的 EMI 计算器：规划提前还款、模拟宽限期、切换货币并导出您的 PDF 路线图。',
    loan_amount: '贷款金额', rate_of_interest: '年利率', loan_tenure: '贷款期限',
    yr: '年', mo: '月',
    monthly_emi: '月供', principal: '本金', total_interest: '总利息', total_amount: '总金额',
    interest_type: '利息类型', reducing_balance: '递减余额法', flat_rate: '固定利率',
    reducing_balance_desc: '每月按剩余本金计算利息，大多数银行采用此方式。',
    flat_rate_desc: '整个期间按原始本金收取利息，通常总成本更高。',
    currency: '货币', language: '语言',
    moratorium_enable: '启用宽限期',
    moratorium_desc: '暂停一定期限的月供，但利息仍会累计。',
    moratorium_duration: '宽限期时长', months_unit: '月',
    full_moratorium: '完全宽限', full_moratorium_desc: '无需还款,利息计入本金。',
    interest_only: '仅付利息', interest_only_desc: '只支付月利息,本金不变。',
    moratorium_interest_added: '宽限期利息已并入',
    you_save: '您节省',
    prepayment_title: '提前还款模拟',
    prepayment_desc: '添加一次性提前还款或每月额外还款金额,查看可节省的利息与期限。',
    extra_every_month: '每月额外金额',
    extra_every_month_desc: '在常规月供之上支付。直接减少本金。',
    none: '无',
    lump_sum_title: '一次性提前还款',
    lump_sum_desc: '可在贷款期间任何月份加入一笔还款。',
    add: '添加', month: '月份', at_month: '在第',
    interest_saved: '节省利息', tenure_shortened: '缩短期限', new_payoff_time: '新还清时间',
    amortization_title: '还款计划表',
    amortization_desc: '逐月明细',
    payoff_in: '还清于',
    rows: '行',
    phase: '阶段', payment: '还款', prepay: '提前还款', balance: '余额',
    moratorium: '宽限期', emi_phase: '月供',
    download_pdf: '下载 PDF',
    download_csv: '下载 CSV',
    what_is_emi_title: '什么是 EMI 计算器?',
    what_is_emi_body: 'EMI 计算器是一种简单工具,可帮您计算每月为房贷、车贷、个人贷款或教育贷款支付的固定金额。仅需移动滑块,即可即时看到月供、总利息以及应付总额。',
    feature_1_t: '即时结果', feature_1_d: '调整数值时,月供、利息与总金额实时更新。',
    feature_2_t: '清晰拆分', feature_2_d: '本金与利息的可视化拆分,让您了解每一分钱的去向。',
    feature_3_t: '更好预算', feature_3_d: '尝试不同期限,找到符合月度现金流的月供。',
    feature_4_t: '更智能储蓄', feature_4_d: '并排比较贷款方案,选择利息最低的选项。',
    formula_title: 'EMI 公式',
    formula_note: '其中 P 为本金,R 为月利率,N 为月供总期数。',
    faq_title: '常见问题',
    faq_desc: '关于 EMI 与贷款规划您需要了解的一切。',
    other_calc_title: '其他计算器',
    other_calc_desc: '探索更多财务规划工具。',
    calculate: '计算',
    footer_products: '产品', footer_calculators: '计算器', footer_company: '公司', footer_support: '支持',
    footer_copyright: '计算器结果仅供参考。',
    invest_the_difference: '将差额用于投资',
    all_products: '全部产品',
  },
  fr: {
    app_name: 'EMIWise',
    home: 'Accueil', calculators: 'Calculatrices', emi_calculator: 'Calculatrice EMI',
    login: 'Connexion', register: 'Inscription',
    title: 'Calculatrice EMI',
    subtitle: 'La calculatrice EMI la plus complète : planifiez les remboursements anticipés, modélisez les moratoires, changez de devise et exportez votre feuille de route PDF.',
    loan_amount: 'Montant du prêt', rate_of_interest: 'Taux d\'intérêt (annuel)', loan_tenure: 'Durée du prêt',
    yr: 'An', mo: 'Mois',
    monthly_emi: 'Mensualité', principal: 'Capital', total_interest: 'Intérêts totaux', total_amount: 'Montant total',
    interest_type: 'Type d\'intérêt', reducing_balance: 'Solde dégressif', flat_rate: 'Taux fixe',
    reducing_balance_desc: 'Les intérêts sont calculés chaque mois sur le solde restant. Standard pour la plupart des banques.',
    flat_rate_desc: 'Les intérêts sont calculés sur le capital initial pour toute la durée. Généralement plus coûteux.',
    currency: 'Devise', language: 'Langue',
    moratorium_enable: 'Activer une période de moratoire',
    moratorium_desc: 'Suspendre les mensualités pendant une période définie. Les intérêts continuent de courir.',
    moratorium_duration: 'Durée du moratoire', months_unit: 'mois',
    full_moratorium: 'Moratoire complet', full_moratorium_desc: 'Aucun paiement. Les intérêts s\'ajoutent au capital.',
    interest_only: 'Intérêts seuls', interest_only_desc: 'Payez uniquement les intérêts mensuels ; le capital est inchangé.',
    moratorium_interest_added: 'Intérêts de moratoire ajoutés',
    you_save: 'Vous économisez',
    prepayment_title: 'Simulateur de remboursement anticipé',
    prepayment_desc: 'Ajoutez des remboursements ponctuels ou un montant mensuel supplémentaire et voyez les intérêts et la durée économisés.',
    extra_every_month: 'Montant supplémentaire mensuel',
    extra_every_month_desc: 'Payé en plus de la mensualité régulière. Réduit directement le capital.',
    none: 'Aucun',
    lump_sum_title: 'Remboursements anticipés ponctuels',
    lump_sum_desc: 'Ajoutez un paiement à n\'importe quel mois du prêt.',
    add: 'Ajouter', month: 'Mois', at_month: 'au mois',
    interest_saved: 'Intérêts économisés', tenure_shortened: 'Durée réduite', new_payoff_time: 'Nouvelle durée',
    amortization_title: 'Tableau d\'amortissement',
    amortization_desc: 'Détail mois par mois',
    payoff_in: 'remboursé en',
    rows: 'lignes',
    phase: 'Phase', payment: 'Paiement', prepay: 'Anticipé', balance: 'Solde',
    moratorium: 'Moratoire', emi_phase: 'Mensualité',
    download_pdf: 'Télécharger le PDF',
    download_csv: 'Télécharger le CSV',
    what_is_emi_title: 'Qu\'est-ce qu\'une calculatrice EMI ?',
    what_is_emi_body: 'Une calculatrice EMI est un outil simple pour connaître le montant fixe payé chaque mois pour un prêt immobilier, automobile, personnel ou étudiant. Déplacez les curseurs pour voir instantanément la mensualité, les intérêts totaux et le montant total dû.',
    feature_1_t: 'Résultats instantanés', feature_1_d: 'La mensualité, les intérêts et le total se mettent à jour en temps réel.',
    feature_2_t: 'Répartition claire', feature_2_d: 'Répartition visuelle capital / intérêts pour savoir où va chaque euro.',
    feature_3_t: 'Meilleur budget', feature_3_d: 'Testez différentes durées pour trouver une mensualité confortable.',
    feature_4_t: 'Économiser mieux', feature_4_d: 'Comparez les offres et choisissez celle avec le coût d\'intérêts le plus bas.',
    formula_title: 'Formule EMI',
    formula_note: 'où P est le capital, R le taux mensuel et N le nombre de mensualités.',
    faq_title: 'Questions fréquentes',
    faq_desc: 'Tout ce qu\'il faut savoir sur les EMI et la planification de prêts.',
    other_calc_title: 'Autres calculatrices',
    other_calc_desc: 'Découvrez plus d\'outils pour planifier vos finances.',
    calculate: 'Calculer',
    footer_products: 'Produits', footer_calculators: 'Calculatrices', footer_company: 'Entreprise', footer_support: 'Support',
    footer_copyright: 'Les calculatrices sont à titre indicatif uniquement.',
    invest_the_difference: 'Investir la différence',
    all_products: 'Tous les produits',
  },
  de: {
    app_name: 'EMIWise',
    home: 'Startseite', calculators: 'Rechner', emi_calculator: 'EMI-Rechner',
    login: 'Anmelden', register: 'Registrieren',
    title: 'EMI-Rechner',
    subtitle: 'Der umfassendste EMI-Rechner: Sondertilgungen planen, Moratorien modellieren, Währungen wechseln und Ihren PDF-Fahrplan exportieren.',
    loan_amount: 'Kreditbetrag', rate_of_interest: 'Zinssatz (p.a.)', loan_tenure: 'Kreditlaufzeit',
    yr: 'J', mo: 'M',
    monthly_emi: 'Monatliche Rate', principal: 'Kapital', total_interest: 'Gesamtzinsen', total_amount: 'Gesamtbetrag',
    interest_type: 'Zinsart', reducing_balance: 'Restschuldzins', flat_rate: 'Festzins',
    reducing_balance_desc: 'Zinsen werden monatlich auf die Restschuld berechnet. Standard bei den meisten Banken.',
    flat_rate_desc: 'Zinsen werden über die gesamte Laufzeit auf das ursprüngliche Kapital berechnet. Meist teurer.',
    currency: 'Währung', language: 'Sprache',
    moratorium_enable: 'Moratoriumszeit aktivieren',
    moratorium_desc: 'Ratenzahlungen für einen bestimmten Zeitraum pausieren. Zinsen laufen weiter.',
    moratorium_duration: 'Moratoriumsdauer', months_unit: 'Monate',
    full_moratorium: 'Vollständiges Moratorium', full_moratorium_desc: 'Keine Zahlung. Zinsen werden zum Kapital addiert.',
    interest_only: 'Nur Zinsen', interest_only_desc: 'Nur monatliche Zinsen zahlen; Kapital bleibt unverändert.',
    moratorium_interest_added: 'Moratoriumszinsen hinzugefügt',
    you_save: 'Sie sparen',
    prepayment_title: 'Sondertilgungs-Simulator',
    prepayment_desc: 'Einmalige Sondertilgungen oder monatliche Zusatzbeträge hinzufügen und Ersparnisse sehen.',
    extra_every_month: 'Zusätzlicher Betrag pro Monat',
    extra_every_month_desc: 'Wird zusätzlich zur regulären Rate gezahlt. Reduziert direkt das Kapital.',
    none: 'Keine',
    lump_sum_title: 'Einmalige Sondertilgungen',
    lump_sum_desc: 'Zahlung zu einem beliebigen Monat der Laufzeit hinzufügen.',
    add: 'Hinzufügen', month: 'Monat', at_month: 'im Monat',
    interest_saved: 'Zinsen gespart', tenure_shortened: 'Laufzeit verkürzt', new_payoff_time: 'Neue Laufzeit',
    amortization_title: 'Tilgungsplan',
    amortization_desc: 'Monat-für-Monat Aufschlüsselung',
    payoff_in: 'abbezahlt in',
    rows: 'Zeilen',
    phase: 'Phase', payment: 'Zahlung', prepay: 'Sonderzahlung', balance: 'Restschuld',
    moratorium: 'Moratorium', emi_phase: 'Rate',
    download_pdf: 'PDF herunterladen',
    download_csv: 'CSV herunterladen',
    what_is_emi_title: 'Was ist ein EMI-Rechner?',
    what_is_emi_body: 'Ein EMI-Rechner ist ein einfaches Werkzeug, um den festen monatlichen Betrag für Immobilien-, Auto-, Privat- oder Bildungskredite zu bestimmen. Bewegen Sie die Regler und sehen Sie sofort Monatsrate, Gesamtzinsen und Gesamtbetrag.',
    feature_1_t: 'Sofortige Ergebnisse', feature_1_d: 'Rate, Zinsen und Gesamtbetrag aktualisieren sich in Echtzeit.',
    feature_2_t: 'Klare Aufteilung', feature_2_d: 'Visuelle Aufteilung Kapital vs. Zinsen — jeder Euro sichtbar.',
    feature_3_t: 'Besseres Budget', feature_3_d: 'Probieren Sie verschiedene Laufzeiten für eine passende Rate.',
    feature_4_t: 'Klüger sparen', feature_4_d: 'Angebote vergleichen und die günstigste Option wählen.',
    formula_title: 'EMI-Formel',
    formula_note: 'P = Kapital, R = Monatszinssatz, N = Anzahl der Monatsraten.',
    faq_title: 'Häufig gestellte Fragen',
    faq_desc: 'Alles Wichtige zu EMIs und Kreditplanung.',
    other_calc_title: 'Weitere Rechner',
    other_calc_desc: 'Entdecken Sie mehr Werkzeuge für Ihre Finanzplanung.',
    calculate: 'Berechnen',
    footer_products: 'Produkte', footer_calculators: 'Rechner', footer_company: 'Unternehmen', footer_support: 'Support',
    footer_copyright: 'Rechner dienen nur zur Veranschaulichung.',
    invest_the_difference: 'Differenz investieren',
    all_products: 'Alle Produkte',
  },
  nl: {
    app_name: 'EMIWise',
    home: 'Home', calculators: 'Rekenmachines', emi_calculator: 'EMI-rekenmachine',
    login: 'Inloggen', register: 'Registreren',
    title: 'EMI-rekenmachine',
    subtitle: 'De meest complete EMI-rekenmachine: plan extra aflossingen, modelleer moratoria, wissel van valuta en exporteer uw pdf-routekaart.',
    loan_amount: 'Leenbedrag', rate_of_interest: 'Rente (p.j.)', loan_tenure: 'Looptijd',
    yr: 'Jr', mo: 'Md',
    monthly_emi: 'Maandelijkse termijn', principal: 'Hoofdsom', total_interest: 'Totale rente', total_amount: 'Totaalbedrag',
    interest_type: 'Rentetype', reducing_balance: 'Afnemend saldo', flat_rate: 'Vast tarief',
    reducing_balance_desc: 'Rente wordt maandelijks berekend over het openstaande saldo. Standaard bij de meeste banken.',
    flat_rate_desc: 'Rente wordt berekend over de oorspronkelijke hoofdsom voor de gehele looptijd. Meestal duurder.',
    currency: 'Valuta', language: 'Taal',
    moratorium_enable: 'Moratoriumperiode inschakelen',
    moratorium_desc: 'Termijnbetalingen tijdelijk pauzeren. Rente loopt door.',
    moratorium_duration: 'Moratoriumduur', months_unit: 'maanden',
    full_moratorium: 'Volledig moratorium', full_moratorium_desc: 'Geen betaling. Rente wordt bij hoofdsom opgeteld.',
    interest_only: 'Alleen rente', interest_only_desc: 'Alleen maandelijkse rente betalen; hoofdsom blijft gelijk.',
    moratorium_interest_added: 'Moratoriumrente toegevoegd',
    you_save: 'U bespaart',
    prepayment_title: 'Extra-aflossings-simulator',
    prepayment_desc: 'Voeg eenmalige aflossingen of een maandelijks extra bedrag toe en zie hoeveel rente en tijd u bespaart.',
    extra_every_month: 'Extra bedrag per maand',
    extra_every_month_desc: 'Bovenop uw reguliere termijn. Verlaagt direct de hoofdsom.',
    none: 'Geen',
    lump_sum_title: 'Eenmalige extra aflossingen',
    lump_sum_desc: 'Voeg een betaling toe op een willekeurige maand.',
    add: 'Toevoegen', month: 'Maand', at_month: 'in maand',
    interest_saved: 'Rente bespaard', tenure_shortened: 'Looptijd verkort', new_payoff_time: 'Nieuwe aflostijd',
    amortization_title: 'Aflossingsschema',
    amortization_desc: 'Maand-voor-maand overzicht',
    payoff_in: 'afgelost in',
    rows: 'rijen',
    phase: 'Fase', payment: 'Betaling', prepay: 'Extra', balance: 'Saldo',
    moratorium: 'Moratorium', emi_phase: 'Termijn',
    download_pdf: 'PDF downloaden',
    download_csv: 'CSV downloaden',
    what_is_emi_title: 'Wat is een EMI-rekenmachine?',
    what_is_emi_body: 'Een EMI-rekenmachine helpt u het vaste maandbedrag te berekenen voor een hypotheek, autolening, persoonlijke lening of studielening. Verplaats de schuiven en zie direct uw maandtermijn, totale rente en totaal te betalen bedrag.',
    feature_1_t: 'Direct resultaat', feature_1_d: 'Termijn, rente en totaal worden live bijgewerkt.',
    feature_2_t: 'Duidelijke verdeling', feature_2_d: 'Visuele verdeling van hoofdsom versus rente.',
    feature_3_t: 'Betere budgettering', feature_3_d: 'Test verschillende looptijden om een passende termijn te vinden.',
    feature_4_t: 'Slimmer besparen', feature_4_d: 'Vergelijk aanbiedingen en kies de goedkoopste.',
    formula_title: 'EMI-formule',
    formula_note: 'P = hoofdsom, R = maandrente, N = aantal maandtermijnen.',
    faq_title: 'Veelgestelde vragen',
    faq_desc: 'Alles over EMI\'s en het plannen van leningen.',
    other_calc_title: 'Andere rekenmachines',
    other_calc_desc: 'Ontdek meer tools voor uw financiële planning.',
    calculate: 'Bereken',
    footer_products: 'Producten', footer_calculators: 'Rekenmachines', footer_company: 'Bedrijf', footer_support: 'Ondersteuning',
    footer_copyright: 'Rekenmachines zijn slechts ter illustratie.',
    invest_the_difference: 'Investeer het verschil',
    all_products: 'Alle producten',
  },
};

const AppSettingsCtx = createContext(null);

const safeGet = (key, fallback) => {
  try {
    return localStorage.getItem(key) || fallback;
  } catch (err) {
    console.warn(`[EMIWise] localStorage read failed for "${key}"`, err);
    return fallback;
  }
};

const safeSet = (key, value) => {
  try {
    localStorage.setItem(key, value);
  } catch (err) {
    console.warn(`[EMIWise] localStorage write failed for "${key}"`, err);
  }
};

// Detect the best-fit language + currency from the browser locale.
function detectDefaultLocale() {
  try {
    const raw = ((navigator && (navigator.language || (navigator.languages && navigator.languages[0]))) || 'en').toLowerCase();
    if (raw.startsWith('hi')) return { lang: 'hi', currency: 'INR' };
    if (raw.startsWith('zh')) return { lang: 'zh', currency: 'USD' };
    if (raw.startsWith('fr')) return { lang: 'fr', currency: 'EUR' };
    if (raw.startsWith('de')) return { lang: 'de', currency: 'EUR' };
    if (raw.startsWith('nl')) return { lang: 'nl', currency: 'EUR' };
    if (raw.startsWith('en-in')) return { lang: 'en', currency: 'INR' };
    if (raw.startsWith('en-gb')) return { lang: 'en', currency: 'GBP' };
    if (raw.startsWith('en-au') || raw.startsWith('en-ca') || raw.startsWith('en-us')) return { lang: 'en', currency: 'USD' };
    if (raw.startsWith('en')) return { lang: 'en', currency: 'USD' };
    return { lang: 'en', currency: 'USD' };
  } catch (err) {
    return { lang: 'en', currency: 'INR' };
  }
}

export function AppSettingsProvider({ children }) {
  const [lang, setLangRaw] = useState(() => {
    const saved = safeGet('emi_lang', null);
    if (saved) return saved;
    return detectDefaultLocale().lang;
  });
  const [currency, setCurrencyRaw] = useState(() => {
    const saved = safeGet('emi_currency', null);
    if (saved) return saved;
    // Default is always INR (per product spec); users can switch via the header.
    return 'INR';
  });
  const [theme, setThemeRaw] = useState(() => safeGet('emi_theme', 'light'));

  const setLang = React.useCallback((v) => { setLangRaw(v); safeSet('emi_lang', v); }, []);
  const setCurrency = React.useCallback((v) => { setCurrencyRaw(v); safeSet('emi_currency', v); }, []);
  const setTheme = React.useCallback((v) => { setThemeRaw(v); safeSet('emi_theme', v); }, []);

  // Apply theme class to <html>
  React.useEffect(() => {
    const root = document.documentElement;
    if (theme === 'dark') root.classList.add('dark');
    else root.classList.remove('dark');
  }, [theme]);

  const t = React.useCallback((key) => {
    const table = dict[lang] || dict.en;
    return table[key] || dict.en[key] || key;
  }, [lang]);

  const value = React.useMemo(
    () => ({ lang, setLang, currency, setCurrency, theme, setTheme, t }),
    [lang, setLang, currency, setCurrency, theme, setTheme, t]
  );

  return <AppSettingsCtx.Provider value={value}>{children}</AppSettingsCtx.Provider>;
}

export function useAppSettings() {
  const ctx = useContext(AppSettingsCtx);
  if (!ctx) throw new Error('useAppSettings must be used inside AppSettingsProvider');
  return ctx;
}
